import { defineSlotRecipe } from '@chakra-ui/react';
import { dataListAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: dataListAnatomy.keys(),
  variants: {
    variant: {
      solid: {
        itemLabel: {
          color: 'fg',
          textStyle: 'sm',
        },
        itemValue: {
          color: 'fg.muted',
        },
      },
    },
  },
});
